export function StatCard({ label, value, sub, accent, testid }) {
  return (
    <div className="grid-card p-6" data-testid={testid}>
      <p className="text-xs uppercase tracking-wider text-muted-foreground mb-2">{label}</p>
      <p className={`font-serif text-4xl tracking-tight ${accent ? "text-accent" : ""}`}>{value}</p>
      {sub && <p className="text-xs text-muted-foreground mt-2">{sub}</p>}
    </div>
  );
}
